<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { fly } from 'svelte/transition';
  import { ensureHttps } from '../../lib/url';
  import ReaderFrameHeader from './ReaderFrameHeader.svelte';
  import ProgressBar from 'svelte-progress-bar';

  export let item: ReaderFrameItem;
  export let overlay = false;

  const dispatch = createEventDispatcher();

  let progress: ProgressBar;

  $: itemName = item.name;
  $: if (itemName && progress) {
    onLoadStart();
  }

  interface ReaderFrameItem {
    url: string;
    name: string;
    featured?: boolean;
  }

  function onSelfClick() {
    if (!overlay) return;

    dispatch('close');
  }

  function onLoadStart() {
    progress.reset();
    progress.start();
  }

  function onLoad() {
    progress.complete();
  }
</script>

<div
  class="reader-iframe"
  class:overlay
  on:click|self={onSelfClick}
  transition:fly={{ duration: overlay ? 300 : 0, x: 50 }}
>
  <div class="ri-inner">
    {#if item}
      <ReaderFrameHeader {item} on:saved />
      <div class="progress-bar-container">
        <ProgressBar bind:this={progress} color="var(--color-blue--500)" />
      </div>
      <iframe
        src={ensureHttps(item.featured ? item.url : `${item.url}?ref=thestocks.im`)}
        title={item.name}
        frameborder="0"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
        allowfullscreen={true}
        allow="clipboard-write"
        on:load={onLoad}
      />
    {/if}
  </div>
</div>

<style lang="scss">
  .reader-iframe {
    flex: 1;

    &.overlay {
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: rgba(white, 0.9);
      padding-left: 30%;
      left: 0;
      top: 0;

      .ri-inner {
        box-shadow: -12px 0 35px rgba(47, 45, 94, 0.25);
      }
    }
  }

  .ri-inner {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
  }

  iframe {
    width: 100%;
    flex: 1;
    overflow: hidden;
    background-color: var(--color-bg--lightest);
  }

  .progress-bar-container {
    position: relative;
    width: 100%;
    z-index: 0;
    :global(.svelte-progress-bar) {
      position: absolute;
      overflow: hidden;
      top: -2px;
    }
  }
</style>
